var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldRender
    ? _c("Photoswipe", {
        attrs: {
          gid: _vm.gid,
          "gallery-items": _vm.galleryItems,
          options: _vm.options
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(ref) {
                var openGallery = ref.openGallery
                return [
                  _c(
                    "button",
                    {
                      class: _vm.className,
                      on: {
                        click: function($event) {
                          return _vm.onButtonClick(openGallery)
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]
                  )
                ]
              }
            }
          ],
          null,
          false,
          2015121984
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }